import Vue from 'vue';
import axios from 'axios';

import '@/styles/fonts.scss';
import '@/styles/overrides.scss';

import 'vue-class-component/hooks';

import '@/plugins/vue-font-awesome';
import '@/plugins/vue-meta';
import '@/plugins/http';

import useAuth0PluginAsync from '@/plugins/auth0';
import vuetify from '@/plugins/vuetify';

import router from '@/router';

import store from '@/store';

import App from '@/App.vue';

Vue.config.productionTip = false;

useAuth0PluginAsync().then(() => {
  const options = { router, vuetify, store };

  new Vue({
    ...options,
    render: (h) => h(App),
    mounted() {
      this.$http.instance.interceptors.request.use((config) => {
        const conf = config;

        const source = axios.CancelToken.source();
        conf.cancelToken = source.token;

        this.$store.commit('http/addCancelToken', source);

        return conf;
      }, (error: Error) => Promise.reject(error));
    },
  }).$mount('#app');
  // eslint-disable-next-line no-console
}).catch(console.error);
